import { useSelector } from 'react-redux';

import { LOG_TO_RELEASE } from '../actions/logs';
import { MODE } from '../config';
import { getFormValues } from '../selectors/forms';
import {
    Platform,
    React,
    ScrollView,
    Text
} from './react';

export const Log = ({
    value,
    text,
    pre = false,
    display = true,
    useGlobalPreformat = false,
}) => {
    const forms = useSelector(getFormValues);
    const usePreformat = useGlobalPreformat ? !!forms?.Preformat : pre;
    const getJson = (obj) => {
        try {
            return `${JSON.stringify(obj, null, 2)}`;
        } catch (e) {
            return 'Error JSON.stringify';
        }
    };
    // eslint-disable-next-line no-console
    console.log(`LOG: ${text}`, value);
    const jsonString = getJson(value);
    return (
        display &&
        (!usePreformat ? (
            <ScrollView>
                <Text>
                    {!!text && <Text>{text}:</Text>}
                    {jsonString}
                </Text>
            </ScrollView>
        ) : (
            <ScrollView
                style={{
                    flex: 1,
                    backgroundColor: '#f5f5f5',
                    padding: 10,
                }}
                contentContainerStyle={{ flexGrow: 1 }}
            >
                <ScrollView
                    horizontal
                    contentContainerStyle={{ flexGrow: 1 }}
                    showsHorizontalScrollIndicator
                >
                    <Text
                        style={{
                            fontFamily: Platform.select({
                                ios: 'Courier',
                                android: 'monospace',
                            }),
                            fontSize: 14,
                            color: '#333',
                        }}
                    >
                        {jsonString}
                    </Text>
                </ScrollView>
            </ScrollView>
        ))
    );
};

export const QAMode = ({ children }) => {
    try {
        const forms = useSelector(getFormValues);

        if (MODE !== 'qa' && !LOG_TO_RELEASE) {
            return null;
        }

        return forms?.QAMode ? children : null;
    } catch (e) {
        console.log('Error in QAMode', e);
        return null;
    }
};
